
const baseStoreUrl = "Store"
  const endpoints = {
    getPortfolioUserByStoreFilter:`${baseStoreUrl}/GetAllPortfolioUser`,
    getUserInfoesByPhoneNumber:`${baseStoreUrl}/GetPortfolioUserByPhoneNumber`,
    getPortfolioUserByStore:`${baseStoreUrl}/GetPortfolioUserByStore`,
   addPortfolioUserByStore:`${baseStoreUrl}/AddPortfolioUserByStore`,
   editPortfolioUserByStore:`${baseStoreUrl}/EditPortfolioUserByStore`,
   editPortfolioUserByStoreList:`${baseStoreUrl}/EditPortfolioUserByStoreList`,
   deletePortfolioUserByStore:`${baseStoreUrl}/DeletePortfolioUserByStore`,
   inviteUser:`${baseStoreUrl}/InviteUser`,
   
  };
  
  export default endpoints;